module.exports = __webpack_public_path__ + "img/shop-banner.fd464265.png";